<template>
  <div class="gallery__container">
    <div class="gallery__first-row">
      <img
        class="gallery__img"
        v-for="card in firstRow"
        :key="card.img"
        :src="card.img"
        alt=""
        @click="goToPage(card.id)"
      />
    </div>
    <div class="gallery__second-row">
      <img
        class="gallery__img"
        v-for="card in secondRow"
        :key="card.img"
        :src="card.img"
        alt=""
        @click="goToPage(card.id)"
      />
    </div>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Observer } from "gsap/Observer";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(Observer);

export default {
  data() {
    return {
      tl: null,

      firstRow: [
        {
          img: require("@/assets/images/webDevelopment/1.png"),
          id: 1,
        },
        {
          img: require("@/assets/images/webDevelopment/2.png"),
          id: 2,
        },
        {
          img: require("@/assets/images/webDevelopment/3.png"),
          id: 3,
        },
        {
          img: require("@/assets/images/webDevelopment/4.png"),
          id: 4,
        },
        {
          img: require("@/assets/images/webDevelopment/5.png"),
          id: 5,
        },
      ],
      secondRow: [
        {
          img: require("@/assets/images/webDevelopment/6.png"),
          id: 6,
        },
        {
          img: require("@/assets/images/webDevelopment/7.png"),
          id: 7,
        },
        {
          img: require("@/assets/images/webDevelopment/8.png"),
          id: 8,
        },
        {
          img: require("@/assets/images/webDevelopment/9.png"),
          id: 9,
        },
        {
          img: require("@/assets/images/webDevelopment/10.png"),
          id: 10,
        },
      ],
    };
  },
  mounted() {
    this.tl = gsap.timeline();

    this.tl.fromTo(
      ".gallery__first-row",
      { xPercent: -50 },
      {
        scrollTrigger: {
          trigger: ".gallery__container",
          start: "0% 90%",
          end: "50% 20%",
          scrub: 2,

          // markers: true,
        },
        xPercent: 0,
      }
    );
    this.tl.fromTo(
      ".gallery__second-row",
      { xPercent: 0 },
      {
        scrollTrigger: {
          trigger: ".gallery__container",
          start: "50% 90%",
          end: "100% 20%",
          scrub: 2,

          // markers: true,
        },
        xPercent: -50,
      }
    );

    ScrollTrigger.refresh(true);
  },
  methods: {
    goToPage(id) {
      if (id == 1 || id == 9) {
        this.$router.push("/cardinar");
      } else if (id == 7 || id == 10) {
        this.$router.push("/puzzle");
      } else if (id == 4 || id == 8) {
        this.$router.push("/akfasavdo");
      } else if (id == 2) {
        this.$router.push("/ytong");
      } else if (id == 3) {
        this.$router.push("/smm");
      } else if (id == 5) {
        this.$router.push("/maxdecor");
      } else if (id == 6) {
        this.$router.push("/shtarsystem");
      } else {
        this.$router.push("/web-development");
      }
    },
  },
  beforeUnmount() {
    this.tl.kill();
    this.tl = null;
  },
};
</script>

<style lang="scss">
$MyMaxWidth: 1920;
@mixin myAdaptiv-h($pcSize, $mobSize) {
  $addSize: $pcSize - $mobSize;
  $MyMaxWidth: $MyMaxWidth - 320;
  height: calc(
    #{$mobSize + px} + #{$addSize} * ((100vw - 320px) / #{$MyMaxWidth})
  );
  @media (min-width: 1920px) {
    height: $pcSize + px;
  }
}
@mixin MyAdaptiv-row-gap($pcSize, $mobSize) {
  $addSize: $pcSize - $mobSize;
  $MyMaxWidth: $MyMaxWidth - 320;
  row-gap: calc(
    #{$mobSize + px} + #{$addSize} * ((100vw - 320px) / #{$MyMaxWidth})
  );
  @media (min-width: 1920px) {
    row-gap: $pcSize + px;
  }
}

@mixin MyAdaptiv-column-gap($pcSize, $mobSize) {
  $addSize: $pcSize - $mobSize;
  $MyMaxWidth: $MyMaxWidth - 320;
  column-gap: calc(
    #{$mobSize + px} + #{$addSize} * ((100vw - 320px) / #{$MyMaxWidth})
  );
  @media (min-width: 1920px) {
    column-gap: $pcSize + px;
  }
}

.gallery__container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @include MyAdaptiv-row-gap(30, 7);

  @include myAdaptiv-h(890, 217);
  width: 100%;

  overflow: hidden;
}

.gallery__first-row,
.gallery__second-row {
  display: flex;
  @include MyAdaptiv-column-gap(30, 7);

  width: 100%;
  height: 50%;

  .gallery__img {
    width: 100%;
    height: 100%;

    cursor: pointer;
  }
}
</style>
